<script>
import IntegrationsBase from "@/components/tools/IntegrationsBase.vue";
import Alpaclass from "@/components/tools/modals/member-area/Alpaclass.vue";
import Astron from "@/components/tools/modals/member-area/Astron.vue";
import Cademi from "@/components/tools/modals/member-area/Cademi.vue";
import Ead from "@/components/tools/modals/member-area/Ead.vue";
import Kajabi from "@/components/tools/modals/member-area/Kajabi.vue";
import Memberkit from "@/components/tools/modals/member-area/Memberkit.vue";
import OcePlay from "@/components/tools/modals/member-area/OcePlay.vue";

export default {
  extends: IntegrationsBase,
  data() {
    return {
      name: "Área de membros",
      subtitle: "Integre sua área de membros à Blitzpay.",
      newModal: true
    };
  },
  computed: {
    options() {
      return [
        {
          title: "Kajabi",
          image: require("@/assets/images/integrations/kajabi.svg"),
          description:
            "Integre sua área de membros da plataforma Kajabi à Blitzpay.",
          modal: Kajabi,
          name: "kajabi",
          link: "https://kajabi.com/"
        },
        {
          title: "Memberkit",
          image: require("@/assets/images/integrations/memberkit.svg"),
          description:
            "Integre sua área de membros da plataforma Memberkit à Blitzpay.",
          modal: Memberkit,
          name: "memberkit",
          link: "https://memberkit.com.br/"
        },
        {
          title: "Cademí",
          image: require("@/assets/images/integrations/cademi.svg"),
          description:
            "Integre sua área de membros da plataforma Cademí à Blitzpay.",
          modal: Cademi,
          name: "cademi",
          link: "https://cademi.com.br/"
        },
        {
          title: "Astron Members",
          image: require("@/assets/images/integrations/astron.svg"),
          description:
            "Integre sua área de membros da plataforma Astron Members à Blitzpay.",
          modal: Astron,
          name: "astron",
          link: "https://www.astronmembers.com.br/"
        },
        {
          title: "EAD",
          image: require("@/assets/images/integrations/ead.svg"),
          description:
            "Integre sua área de membros da EAD plataforma à Blitzpay.",
          modal: Ead,
          name: "eadplataform",
          link: "https://eadplataforma.com/"
        },
        {
          title: "Alpaclass",
          image: require("@/assets/images/integrations/alpaclass.svg"),
          description:
            "Integre sua área de membros da plataforma Alpaclass à Blitzpay.",
          modal: Alpaclass,
          name: "alpaclass",
          link: "https://www.alpaclass.com/"
        },
        {
          title: "OCE Play",
          image: require("@/assets/images/integrations/oce-play.svg"),
          description:
            "Integre sua área de membros da plataforma OCE Play à Blitzpay.",
          modal: OcePlay,
          name: "oceplay"
        }
      ];
    }
  },
  mounted() {
    this.loading = true;
    this.$store
      .dispatch("product/get", { limit: 1000 })
      .finally(() => (this.loading = false));
  }
};
</script>
